import React from 'react';

import { isNudeDomain } from '../../utils/helpers';

import NudeNewsTerms from './NudeNewsTerms';


const TermsAndConditionsPage = () => isNudeDomain ? (
  <NudeNewsTerms />
) : (
  <div className="content">
    <div className="container">
      <h1 className="h2">Naked News Terms and Conditions</h1>
      <p>Effective April 15, 2014</p>
      <div className="well">
        <p>
          <strong>
            Please read these Terms and Conditions of Use
            ("Agreement") carefully before using the services
            offered by Naked News on this website.
            This website and domain name, and any other features,
            content, or applications offered from time to time in
            connection therewith (collectively the "Website")
            are owned by TLE Opportunities, LLC (the "Company").
            The Website is brought to you by the Company, operating as
            “Naked News” in conjunction with TLE Opportunities, LLC,
            a Delaware company and third-party service provider
            authorized by the Company to provide payment processing
            of transactions.  This agreement sets forth the
            legally binding terms and conditions for your use of the
            Website. By using the Website in any manner, including but
            not limited to visiting or browsing the Website, you agree
            to be bound by this Agreement and the Company’s privacy
            policy posted on the Website, which is incorporated herein
            by this reference.  You further acknowledge that the
            Website may include audio, textual and visual depictions
            of a sexual nature, including without limitation, nudity,
            heterosexual and homosexual situations and you agree with
            the following statement: “I understand that when I gain
            access to the communication services of the website
            I will be exposed to visual images, verbal descriptions
            audio sounds and other features and/or products of a
            sexually oriented, frankly erotic nature, which may include
            graphic visual depictions and descriptions of nudity. I am
            voluntarily choosing to do so, because I want to view,
            read and/or hear the various materials and/or order and
            enjoy the use of such products or features, which are
            available, for my own personal enjoyment, information
            and/or education.
          </strong>
        </p>
        <p>
          You may at any time request a copy of this
          Agreement by emailing us at:{' '}
          <a
            encode="javascript"
            href="mailto:support@nakednews.com"
          >
            support@nakednews.com
          </a>
          , Subject: Terms of Use.
        </p>
      </div>

      <h2>1. Modifications to this Agreement</h2>
      <p>
        <strong>
          Company reserves the right, in its sole
          discretion, to modify this Agreement at any time
          by posting a notice on the website, or by
          sending you a notice via email or postal mail.
          You shall be responsible for reviewing and
          becoming familiar with any such modifications.
          such modifications are effective upon first
          posting or notification, and use of the website
          or any services by you following such posting or
          notification constitutes your acceptance of the
          terms and conditions of this Agreement as
          modified. You agree to review this Agreement
          regularly to ensure that you are updated as to
          any changes. This Agreement, together with the
          Company Privacy Policy and any other legal
          notices published by Company on the Website,
          shall constitute the entire agreement between
          you and Company concerning the Website.
        </strong>
      </p>
      <h2>2. Website Access</h2>
      <p>
        <strong>2.1</strong> Subject to your compliance on a
        continuing basis with all of the terms and
        conditions of this Agreement, Company hereby grants
        you permission to use the Website only as set forth
        in this Agreement, and provided that: (i) your use
        of the Website as permitted is solely for your
        personal, noncommercial use; (ii) you will not copy
        or distribute any part of the Website in any medium
        without Company s prior written authorization; (iii)
        you will not alter or modify any part of the Website
        other than as expressly authorized and then only for
        such express purpose; (iv) you may not circumvent,
        disable, violate or attempt to violate, or otherwise
        interfere with the security or integrity of the
        Website, the proper operation of the Website, the
        features that prevent or restrict use or copying of
        any Content (as the term is defined below) or
        enforce limitations on use of the Website or the
        Content therein, or interfere with any activity
        being conducted on the Website; and (v) you may not
        decipher, decompile, disassemble or reverse engineer
        any of the software comprising or in any way making
        up part of the Website.
      </p>
      <p>
        <strong>2.2</strong> In order to access some
        features of the Website, you may have to create a
        membership account. You may never use another s
        account, username or password without permission.
        When creating your account, you must provide
        accurate and complete information. You are solely
        responsible for the activity that occurs on your
        account, and you must keep your account password
        secure. You must notify Company immediately of any
        breach of security or unauthorized use of your
        account. You may be required to expressly accept or
        reject these Terms of Use when you register; you
        agree that any requirement that you do so does not
        in any way vitiate your assent to comply with the
        Terms of Use. Although Company will not be liable
        for your losses caused by any unauthorized use of
        your account, you may be liable for the losses of
        Company or others due to such unauthorized use.
      </p>
      <p>
        <strong>2.3</strong> You agree not to use or launch
        any automated system, including without limitation,
        "robots," "spiders," "offline readers," etc., that
        accesses the Website in a manner that sends more
        request messages to the Company servers in a given
        period of time than a single human can reasonably
        produce in the same period by using a conventional
        web browser. You agree not to collect or harvest any
        personally identifiable information, including
        account names, from the Website, nor to use the
        communication systems provided by the Website for
        any commercial solicitation purposes. Company
        reserves the right in its sole discretion to block
        access or discontinue services to offenders, and to
        investigate and take appropriate legal action
        against anyone who, in Company s sole discretion,
        violates this provision, including without
        limitation, reporting you to law enforcement
        authorities.
      </p>
      <h2>3. Intellectual Property Rights</h2>
      <p>
        The content on the Website, including without
        limitation, the text, software, scripts, graphics,
        files, images, photos, sounds, music, videos,
        interactive features and the like (collectively
        "Content") and the trademarks, service marks and
        logos contained therein ("Marks"), are owned by or
        licensed to Company, or used on the Website in
        accordance with fair use provisions or the U.S.
        Copyright Act and equivalent exemptions under
        foreign laws and international conventions. Company
        reserves all rights not expressly granted in and to
        the Website and the Content owned by or licensed to
        Company. You agree to not use, copy, reproduce,
        modify, translate, publish, broadcast, transmit,
        distribute, perform, upload, display, license, sell
        or otherwise exploit for any other purposes
        whatsoever any Content, including, but not limited
        to, image, audio, and visual content, Marks, or
        other proprietary rights not owned by you, (i)
        without the express prior written consent of the
        respective owners, or (ii) in any way that violates
        any right of any third party. If you download or
        print a copy of the Content for personal use, you
        must retain all copyright and other proprietary
        notices contained therein..
      </p>
      <h2>4. Term</h2>
      <p>
        This Agreement shall remain in full force and effect
        while you use the Website. Company may terminate
        your access to the Website or your membership at any
        time, for any reason, and without warning. If your
        membership is terminated other than due to your
        breach of this Agreement or other misconduct, you
        may be entitled to a refund on a pro-rata basis.
      </p>
      <h2>5. Fees</h2>
      <p>
        Basic access to the Website is currently provided
        for free, but certain features of the Website may be
        accessible only to paid subscribers and Company
        reserves the right to change its fees and access
        policies from time to time, in its sole discretion.
        Company has a no charge-back, no refund policy, to
        the extend allowed by applicable law and except as
        otherwise expressly stated herein. You are free to
        cancel your subscription at any time. For your
        convenience billing is recurrent, so you should
        state your wish to cancel your membership at least
        72 hours before it expires. Our customer service
        representatives are available between 9:00 am and
        5:00 pm CST, Monday through Friday, and can be
        contacted through our customer service form
        <a href="/contact">here.</a>
      </p>
      <h2>6. User Comments; Copyright Policy</h2>
      <p>
        <strong>6.1</strong> The Website may permit users to
        post comments in certain areas of the Website ("User
        Comments"). You understand that Company does not
        guarantee any confidentiality with respect to any
        such User Comments.
      </p>
      <p>
        <strong>6.2</strong> You shall be solely responsible
        for your own User Comments and the consequences of
        posting or publishing them. You agree that Company
        has no liability with respect to any User Comments,
        and you hereby irrevocably release Company and its
        officers and directors, employees, agents,
        representatives and affiliates, from any and all
        liability arising out of or relating to User
        Comments or any part thereof. By submitting User
        Comments, you give Company a license to use and
        otherwise exploit such User Comments for any purpose
        in connection with the Website and Company’s other
        related services.
      </p>
      <p>
        <strong>6.3</strong> In connection with User
        Comments, you further agree that you will not: (i)
        publish falsehoods or misrepresentations; (ii)
        submit material that is unlawful, obscene, lewd,
        defamatory, libelous, threatening, pornographic,
        harassing, hateful, racially or ethnically
        offensive, excessively violent, or encourages
        conduct that would be considered a criminal offense,
        give rise to civil liability, violate any law, or is
        otherwise inappropriate or objectionable; (iii) post
        advertisements or solicitations of business; or (iv)
        impersonate another person. Company does not endorse
        any User Comment or any opinion, recommendation, or
        advice expressed therein, and Company expressly
        disclaims any and all responsibility or liability in
        connection with User Comments.
      </p>
      <p>
        <strong>6.4</strong> Company reserves the right to
        decide whether Content or a User Comment is
        inappropriate, or violates this Agreement, including
        without limitation, due to violations of
        intellectual property law, pornography, obscene or
        defamatory material, or excessive length. Company
        also reserves the right, in its sole discretion, to
        reject, refuse to post or remove any posting by you,
        or to restrict, suspend or terminate your access to
        all or any part of the Website at any time, for any
        reason, without prior notice. Notwithstanding the
        foregoing, Company assumes no responsibility for
        monitoring the Website, Content, or User Comments
        for inappropriate conduct, or modifying or removing
        such conduct, Content or User Comments from the
        Website.
      </p>
      <p>
        <strong>6.5</strong> While Company does not actively
        monitor Content posted to the Website, it is Company
        s policy to (1) block access to or remove Content
        that it believes in good faith to be copyrighted
        material that has been illegally copied, displayed
        or distributed by any of its advertisers,
        affiliates, content providers, members or users; and
        (2) discontinue services to and remove repeat
        infringers.
      </p>
      <h2>7. Third Party Websites</h2>
      <p>
        The Website may contain links to third party
        websites that are not owned or controlled by
        Company. When you access third party websites, you
        do so at your own risk. Company encourages you to be
        aware when you leave the Website and to read the
        terms and conditions and privacy policy of each
        third party website that you visit. Company has no
        control over, and assumes no responsibility for, the
        content, accuracy, privacy policies, or practices
        of, or opinions expressed in any third party
        websites, including, without limitation, compliance
        with 18 U.S.C. Section 2257. In addition, Company
        will not and cannot monitor, verify, censor or edit
        the content of any third-party site. By using the
        Website, you expressly relieve Company from any and
        all liability arising from your use of any
        third-party website.
      </p>
      <h2>8. Warranty Disclaimer</h2>
      <p>
        <strong>
          To the fullest extent permitted by law, Company,
          its suppliers and each of their respective
          officers, directors, employees, and agents
          disclaim all warranties, express or implied, in
          connection with the Website and your use
          thereof, including warranties of
          merchantability, fitness for a particular
          purpose and non-infringement. In addition,
          neither Company nor its suppliers, nor any of
          their respective officers, directors, employees,
          and agents, makes any warranties or
          representations about the accuracy or
          completeness of the Website s content or the
          content of any sites linked to the Website, and
          assumes no liability or responsibility for any
          (i) errors, mistakes, or inaccuracies of
          content; (ii) personal injury or property
          damage, of any nature whatsoever, resulting from
          your access to and use of the Website; (iii) any
          unauthorized access to or use of the secure
          servers and/or any and all personal information
          and/or financial information stored therein;
          (iv) any interruption or cessation of
          transmission to or from the Website; (v) any
          bugs, viruses, trojan horses, or the like which
          may be transmitted to or through the Website by
          any third party; and/ or (vi) any errors or
          omissions in any content or for any loss or
          damage of any kind incurred as a result of the
          use of any content posted, emailed, transmitted,
          or otherwise made available via the Website.
          Company does not warrant, endorse, guarantee, or
          assume responsibility for any product or service
          advertised or offered by a third party through
          the Website or any hyperlinked website or
          featured in any advertising, and Company will
          not be a party to or in any way be responsible
          for monitoring any transaction between you and
          third-party providers of products or services.
          The Website is controlled and offered by Company
          from its facilities in the United States of
          America. Company makes no representations that
          the Website is appropriate or available for use
          in other locations. Those who access or use the
          website from other jurisdictions are responsible
          for compliance with local law.
        </strong>
      </p>
      <h2>9. Indemnity</h2>
      <p>
        You agree to defend, indemnify and hold harmless
        Company, its parent corporation, officers,
        directors, employees and agents, from and against
        any and all claims, damages, obligations, losses,
        liabilities, costs or debt, demands, and expenses
        (including but not limited to attorneys fees)
        arising from: (i) your use of and access to the
        Website or any Content that you post thereon; or
        (ii) your violation of any term of this Agreement or
        your representations and warranties set forth above.
      </p>
      <h2>10. Eligibility</h2>
      <p>
        By using the Website, you represent and warrant that
        (i) all registration information you submit is
        accurate and truthful; (ii) you will maintain the
        accuracy of such information; (iii) you are 18 years
        of age or older; (iv) you do not find materials of
        an adult nature objectionable and have the legal
        right to access and possess such materials in the
        community from which you are accessing these
        materials and in which you reside, and (iv) your use
        of the Website does not violate any applicable law
        or regulation. Your membership may be terminated
        without warning if Company believes that you are
        under 18 years of age. You will not permit any
        person(s) under the age of 18 (or who are otherwise
        not legally permitted) to have access to any of the
        materials contained on the Website.
      </p>
      <h2>11. Limitation of Liability</h2>
      <p>
        <strong>
          In no event shall Company, its suppliers, or
          their respective officers, directors, employees,
          or agents, be liable to you or any third party
          for any indirect, incidental, special, punitive,
          or consequential damages whatsoever, including
          lost profits, whether based on warranty,
          contract, tort, or any other legal theory, and
          whether or not the Company is advised of the
          possibility of such damages. The foregoing
          limitation of liability shall apply to the
          fullest extent permitted by law in the
          applicable jurisdiction. Subject to the
          foregoing, Company s liability to you for any
          reason, will be limited to the amount paid, if
          any, by you to Company for the Company services
          in connection with the Website during the term
          of your membership.
        </strong>
      </p>
      <h2>12. Assignment</h2>
      <p>
        You may not transfer or assign this Agreement or any
        rights and licenses granted hereunder without the
        Company s prior written consent. The Company may
        freely transfer, assign, or delegate this Agreement,
        and any of its rights or obligations hereunder.
      </p>
      <h2>13. Miscellaneous</h2>
      <p>
        If there is any dispute about or involving the
        Website, you agree that the dispute shall be
        governed by the laws of the State of Illinois,
        without regard to conflict of laws provisions. Any
        dispute arising from or relating to the subject
        matter of this Agreement shall be finally settled by
        arbitration in Amsterdam, the Netherlands, using the
        English language in accordance with the Arbitration
        Rules and Procedures of Judicial Arbitration and
        Mediation Services, Inc. ("JAMS") then in effect, by
        one commercial arbitrator(s) with substantial
        experience in resolving intellectual property and
        commercial contract disputes, who shall be selected
        from the appropriate list of JAMS arbitrators in
        accordance with the Arbitration Rules and Procedures
        of JAMS. Any arbitrator so selected shall have
        substantial experience in the media industry. The
        arbitrator shall have the authority to grant
        specific performance and to allocate between the
        parties the costs of arbitration (including service
        fees, arbitrator fees and all other fees related to
        the arbitration) in such equitable manner as the
        arbitrator may determine. The prevailing party in
        the arbitration shall be entitled to receive
        reimbursement of its reasonable expenses (including
        reasonable attorneys' fees, expert witness fees and
        all other expenses) incurred in connection
        therewith. Judgment upon the award so rendered may
        be entered in a court having jurisdiction or
        application may be made to such court for judicial
        acceptance of any award and an order of enforcement,
        as the case may be. Notwithstanding the foregoing,
        each party shall have the right to institute an
        action in a court of proper jurisdiction for
        preliminary injunctive relief pending a final
        decision by the arbitrator. For all purposes of this
        Agreement, the parties consent to exclusive
        jurisdiction and venue in the courts of the
        Netherlands. If any provision of this Agreement is
        deemed invalid by a court of competent jurisdiction,
        the invalidity of such provision shall not affect
        the validity of the remaining provisions of this
        Agreement, which shall remain in full force and
        effect. No waiver of any term of this Agreement
        shall be deemed a further or continuing waiver of
        such term or any other term, and Company's failure
        to assert any right or provision under this
        Agreement shall not constitute a waiver of such
        right or provision.
        <strong>
          YOU AND COMPANY AGREE THAT ANY CAUSE OF ACTION
          ARISING OUT OF OR RELATED TO THE WEBSITE MUST
          COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF
          ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION
          IS PERMANENTLY BARRED.
        </strong>
      </p>
      <h2>14. Corporate Address</h2>
      <p>Egalaxy Multimedia Inc.</p>
      <p>Attn: M. Thibodeau</p>
      <p>2133 Danforth Avenue</p>
      <p>Suite 195</p>
      <p>Toronto ON</p>
      <p>M4C 1K2</p>
      <p>Canada</p>
    </div>
  </div>
);

export default TermsAndConditionsPage;
